<template>
  <v-expansion-panel
    style="box-shadow: none;"
    v-model="panel"
  >
    <v-expansion-panel-content :style="myMenuStyle">
      <strong
        slot="header"
        :style="myTitleStyle"
      >{{ catName }}</strong>
      <v-icon
        slot="actions"
        :color="theme.menu_title_color"
      >{{ icon }}</v-icon>
      <div
        v-if="catItems"
        :style="myBoxStyle"
        :id="cat.category_id"
      >
        <v-layout
          v-if="itemListMode === 0 || $mq === 'xs'"
          row
          wrap
        >
          <v-flex
            d-flex
            xs12
            sm12
            md6
            lg6
            xl4
            v-for="i in catItems"
            :key="i.plu_id"
          >
            <list-cat-item
              :item="i"
              :multiplePlus="multiplePlus(i)"
            />
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          row
          wrap
        >
          <v-flex
            d-flex
            xs6
            sm6
            md4
            lg3
            xl2
            v-for="i in catItems"
            :key="i.plu_id"
          >
          <grid-cat-item
            :item="i"
            :multiplePlus="multiplePlus(i)"
          />
          </v-flex>
        </v-layout>
      </div>
      <div v-else-if="!loading">
        <no-cat-item />
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex'
import ListCatItem from '~/components/ListCatItem'
import GridCatItem from '~/components/GridCatItem'
import NoCatItem from '~/components/NoCatItem'

export default {
  name: 'cat-list-component',
  components: {
    'list-cat-item': ListCatItem,
    'grid-cat-item': GridCatItem,
    'no-cat-item': NoCatItem
  },
  props: {
    cat: {
      type: Object,
      default: () => null
    },
    openPanel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      catItems: null,
      panel: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'language', 'itemListMode'
    ]),
    ...mapGetters('menu', [
      'items', 'mainCat', 'selectedPanel'
    ]),
    myMenuStyle () {
      return {
        backgroundColor: this.theme.menu_bg_color
      }
    },
    myTitleStyle () {
      return {
        fontSize: this.config.category_fontsize,
        color: this.theme.menu_title_color
      }
    },
    myBoxStyle () {
      return {
        backgroundColor: this.theme.bg_color,
        borderTop: `8px solid ${this.theme.bg_color}`,
        borderBottom: `8px solid ${this.theme.bg_color}`
      }
    },
    icon () {
      let icon = '$vuetify.icons.expand'
      if (this.panel === 0 && this.loading) {
        icon = 'fas fa-circle-notch fa-spin'
      }
      return icon
    },
    catName () {
      if (this.language !== 'en-SG') {
        return this.cat.alternate_name || this.cat.name
      }
      return this.cat.name
    },
  },
  watch: {
    async panel (val) {
      if (val !== null) {
        this.loading = true
        const key = 'c' + this.cat.category_id
        if (!this.items[key]) {
          await this.$store.dispatch('fetchCatItems', this.cat.category_id)
        }
        this.catItems = this.items[key]
      }
      this.loading = false
    },
    async cat (val) {
      if (this.catItems && this.catItems.length > 0 && this.cat.category_id !== val) {
        this.catItems = []
        // Reset to only first element
        this.panel = this.openPanel ? 0 : null
        if (this.panel === 0) {
          this.loading = true
          const key = 'c' + this.cat.category_id
          if (!this.items[key]) {
            await this.$store.dispatch('fetchCatItems', this.cat.category_id)
          }
          this.catItems = this.items[key]
        }
      }
      if (!this.catItems) {
        this.catItems = []
        // Reset to only first element
        this.panel = this.openPanel ? 0 : null
        if (this.panel === 0) {
          this.loading = true
          const key = 'c' + this.cat.category_id
          if (!this.items[key]) {
            await this.$store.dispatch('fetchCatItems', this.cat.category_id)
          }
          this.catItems = this.items[key]
        }
      }
      this.loading = false
    },
    async selectedPanel (val) {
      if (val !== null) {
        if (this.cat.category_id === val) {
          this.panel = 0
          let element, top
          element = document.getElementById(this.cat.category_id)
          if (element) {
            top = element.offsetTop
            window.scrollTo({
              top: top,
              behavior: 'smooth'
            })
          }
        }
        else {
          this.panel = null
        }
      } else {
        if (this.openPanel) this.panel = 0
      }
    }
  },
  mounted () {
    if (this.openPanel) this.panel = 0
  },
  methods: {
    multiplePlus (item) {
      return this.catItems.find(c => parseInt(c.item_id) === parseInt(item.item_id) && parseInt(c.plu_id) !== parseInt(item.plu_id)) ? true : false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CatList2.vue